import React, { FC } from 'react'
import { CustomButtonProps } from '../../../models/reusable-components'

import './CustomButtons.scss'

const CustomButton: FC<CustomButtonProps> = ({
  type,
  button,
  size = '',
  onClick,
  children,
  disabled,
  className = '',
  contentClass = '',
  ...rest
}) => {
  const settings = {
    className: `button__${button} ${size} ${className} ${rest.inProgress ? 'loading' : ''}`,
    type,
    onClick,
    disabled: disabled
  }

  const preloader = rest.hasOwnProperty('inProgress') && rest.inProgress && (
    <div className='spinner'></div>
  )
  return (
    <button {...settings}>
      <div className={`${contentClass} button__content-wrapper`}>
        {preloader}
        {children}
      </div>
    </button>
  )
}

export default CustomButton
